import { SvgIcon, SvgIconProps } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { resolveColor as resolveColorFromTheme } from '../../../utils/common';
import React from 'react';
import './batteryLevel.scss';

export type BatteryLevel = 0 | 20 | 40 | 60 | 80 | 100;

export type BatteryLevelIconProps = SvgIconProps & {
	level: BatteryLevel;
};

export const BatteryLevelIcon: React.FC<BatteryLevelIconProps> = (props) => {
	const { level, ...svgIconProps } = props;

	const theme = useTheme();
	const filledColor = resolveColorFromTheme(theme, props.color);
	const colorEmpty = '#dde4e9';

	const resolveColor = (forLevel: BatteryLevel) =>
		level >= forLevel ? filledColor : colorEmpty;

	return (
		<SvgIcon {...svgIconProps} viewBox='0 0 66 33'>
			<rect x="1" y="1" width="58.5" height="31" rx="4" stroke="#70767B" strokeWidth="2" fill='transparent' />
			<path d="M59.7812 10.7969H62C63.6569 10.7969 65 12.14 65 13.7969V19.2031C65 20.86 63.6569 22.2031 62 22.2031H59.7812V10.7969Z" stroke="#70767B" strokeWidth="2" fill='transparent'/>
			<rect className='battery-level' x="6.87433" y="6.875" width="6.875" height="19.25" rx="3" style={{ fill: resolveColor(20) }} />
			<rect className='battery-level' x="17.1868" y="6.875" width="6.875" height="19.25" rx="3" style={{ fill: resolveColor(40) }} />
			<rect className='battery-level' x="26.8125" y="6.875" width="6.875" height="19.25" rx="3" style={{ fill: resolveColor(60) }} />
			<rect className='battery-level' x="36.4382" y="6.875" width="6.875" height="19.25" rx="3" style={{ fill: resolveColor(80) }} />
			<rect className='battery-level' x="46.7507" y="6.875" width="6.875" height="19.25" rx="3" style={{ fill: resolveColor(100) }} />
		</SvgIcon>
	);
};
